import ShoppingBag from '../src/ShoppingBag/index';
export default ShoppingBag;
